<template>
  <div>
    <span class="font-base text-black dark:text-white">Edit your Ask TK prompt</span>
  </div>
  <div class="mt-4 w-full h-[300px]">
    <yb-text-editor
      v-model="copilotPrompt"
      class="w-full h-full border yb-border-content overflow-hidden"
      language="text"
      :options="editorOptions"
      @editor-did-mount="editorDidMount"
    />
  </div>
  <div class="mt-4">
    <yb-button
      @click="resetEditor"
      base-button-class="py-1.5"
      button-classes="yb-button-primary rounded-md text-sm"
      icon-classes="yb-button-icon-md text-white fill-current"
      >
      <span>Reset to Default</span>
    </yb-button>
  </div>
</template>

<script>
import { sync } from 'vuex-pathify'
import { defaultPrompt } from '@/app/query/CopilotPrompt'

export default {
  data() {
    return {
      editorOptions: {
        minimap: {
          enabled: false
        },
        scrollBeyondLastLine: false,
        wordWrap: 'on',
        lineNumbers: 'off',
        fontSize: 14,
        lineHeight: 20
      }
    }
  },
  computed: {
    copilotPrompt: sync('settings/editor@copilotPrompt', false)
  },
  methods: {
    editorDidMount(editor) {
      if (!this.copilotPrompt) {
        this.copilotPrompt = defaultPrompt
      }
    },
    resetEditor() {
      this.copilotPrompt = defaultPrompt
      this.$nextTick(() => {
        this.editorOptions = { ...this.editorOptions }
      })
    }
  }
}
</script>
